(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["framezy-bundle-meter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fz-bundle-meter')) {
    class FzBundleMeter extends HTMLElement {
      connectedCallback() {
        this.tiers = (this.dataset.tiers || '')
          .split(',')
          .map((t) => t.split(':').map(Number))
          .filter(([q, o]) => q > 0 && o > 0)
          .sort((a, b) => a[0] - b[0]);
        this.render(Number(this.dataset.cartCount) || 0, this.dataset.inCart === 'true');

        this.refresh = this.refresh.bind(this);
        // Horizon (all versions) + generic cart events
        ['shopify:cart:lines-update', 'cart:update', 'cart:refresh', 'cart-drawer:open'].forEach((name) =>
          document.addEventListener(name, this.refresh)
        );
      }

      disconnectedCallback() {
        ['shopify:cart:lines-update', 'cart:update', 'cart:refresh', 'cart-drawer:open'].forEach((name) =>
          document.removeEventListener(name, this.refresh)
        );
      }

      refresh() {
        // give the cart a moment to finish updating, then read it
        clearTimeout(this._t);
        this._t = setTimeout(async () => {
          try {
            const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
            const inCart = cart.items.some((i) => String(i.product_id) === this.dataset.productId);
            this.render(cart.item_count, inCart);
          } catch (e) {}
        }, 400);
      }

      render(cartCount, inCart) {
        if (!this.tiers.length) return;
        // count this frame too if the shopper hasn't added it yet
        const count = cartCount + (inCart ? 0 : 1);
        const max = this.tiers[this.tiers.length - 1];
        const next = this.tiers.find(([q]) => q > count);
        const current = [...this.tiers].reverse().find(([q]) => q <= count);
        let msg;
        if (!next) {
          msg = (this.dataset.msgMax || '').replace('[percent]', max[1]);
        } else {
          const need = next[0] - count;
          const tpl = need === 1 ? this.dataset.msgNextOne : this.dataset.msgNext;
          msg = (tpl || '').replace('[count]', need).replace('[percent]', next[1]);
          if (current) msg += ` (now −${current[1]}%)`;
        }
        this.querySelector('[data-msg]').textContent = msg;
        const pct = Math.min(1, (count - 1) / Math.max(1, max[0] - 1));
        this.querySelector('[data-fill]').style.width = Math.max(4, pct * 100) + '%';
      }
    }
    customElements.define('fz-bundle-meter', FzBundleMeter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["framezy-size-on-wall"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fz-size-wall')) {
    class FzSizeWall extends HTMLElement {
      connectedCallback() {
        if (this._moving) return; // we're only being moved by place()
        if (!this._home) {
          // remember where the block was placed in the product details
          this._home = document.createComment('fz-size-wall');
          this.before(this._home);
          this._mq = window.matchMedia('(min-width: 750px)');
          this.onChange = this.onChange.bind(this);
          this.place = this.place.bind(this);
          this.checkHeight = this.checkHeight.bind(this);
        }
        document.addEventListener('change', this.onChange);
        this._mq.addEventListener('change', this.place);
        this.fitLabels = this.fitLabels || (() => {
          this.querySelectorAll('.fz-sw__outline').forEach((o) => {
            o.classList.remove('is-stacked', 'is-tiny');
            const label = o.querySelector('span');
            if (!label) return;
            const fits = () => label.offsetWidth <= o.clientWidth - 4 && label.offsetHeight <= o.clientHeight - 4;
            if (fits()) return;
            o.classList.add('is-stacked');
            if (fits()) return;
            o.classList.remove('is-stacked');
            o.classList.add('is-tiny');
          });
        });
        this._fitRo = this._fitRo || new ResizeObserver(() => this.fitLabels());
        this._fitRo.observe(this.querySelector('.fz-sw__wall') || this);
        window.addEventListener('resize', this.checkHeight);
        this.place();
      }

      disconnectedCallback() {
        if (this._moving) return;
        document.removeEventListener('change', this.onChange);
        this._mq.removeEventListener('change', this.place);
        window.removeEventListener('resize', this.checkHeight);
        this._ro?.disconnect();
        this._fitRo?.disconnect();
        this.setHost(null);
      }

      mediaColumn() {
        const start = this._home.parentElement;
        if (!start) return null;
        // works whether the block sits inside "Product details" or directly in the section
        const scopes = ['product-component', '.product-information', '.shopify-section', 'main'];
        for (const sel of scopes) {
          const scope = start.closest(sel);
          const media = scope && scope.querySelector('.product-information__media');
          if (media) return media;
        }
        return null;
      }

      place() {
        const pos = this._mq.matches ? this.dataset.desktop : this.dataset.mobile;
        const media = pos === 'media' ? this.mediaColumn() : null;
        this._moving = true;
        try {
          if (media) {
            // remove a stale copy left behind by a theme re-render
            media.querySelectorAll(`:scope > fz-size-wall[data-block-id="${this.dataset.blockId}"]`).forEach((el) => {
              if (el !== this) el.remove();
            });
            if (this.parentElement !== media || media.lastElementChild !== this) media.append(this);
          } else if (this._home.isConnected && this.previousSibling !== this._home) {
            this._home.after(this);
          }
        } finally {
          this._moving = false;
        }
        this.setHost(media);
      }

      setHost(media) {
        if (this._host && this._host !== media) this._host.classList.remove('fz-sw-host', 'fz-sw-tall');
        this._ro?.disconnect();
        this._host = media;
        if (!media) return;
        media.classList.add('fz-sw-host');
        this._ro = this._ro || new ResizeObserver(this.checkHeight);
        this._ro.observe(media);
        this.checkHeight();
      }

      checkHeight() {
        if (!this._host) return;
        const offset = parseFloat(getComputedStyle(this._host).top) || 0;
        const tall = this._host.scrollHeight > window.innerHeight - offset;
        this._host.classList.toggle('fz-sw-tall', tall);
      }

      onChange(e) {
        const el = e.target;
        const name = this.dataset.option;
        let value = null;
        // Horizon button/swatch pickers: radio inputs with data-option-name
        if (el.matches && el.matches('input[type="radio"]') && el.dataset.optionName === name) value = el.value;
        // Dropdown pickers: <select name="options[Size]">
        if (el.matches && el.matches('select') && el.name === `options[${name}]`) value = el.value;
        if (value !== null) this.select(value);
      }

      select(value) {
        this.querySelectorAll('.fz-sw__outline').forEach((o) => o.classList.toggle('is-active', o.dataset.value === value));
        const t = this.querySelector('[data-title-el]');
        if (t && this.dataset.title) t.textContent = this.dataset.title.replace('[size]', value);
      }
    }
    customElements.define('fz-size-wall', FzSizeWall);
  }
  } catch(e) { console.error(e); }
})();

})();
